var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"youTube"},[(this.$route.query.id === '')?_c('div',[_c('YouTube',{attrs:{"id":this.$route.query.id,"config":_vm.config}})],1):_c('div',[_c('YouTube',{attrs:{"id":this.$route.query.id,"config":_vm.config}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }